module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAUCAYAAAB8gkaAAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADXSURBVEhL3dAxDoMgFAbgXtDRO+ioqwfQ3Rvoblw9STkDJibAASz84VFKMG3TFBOHb3gv8P+Bm1JqTwVlwzBAXddQVdXPKMsYxxEuXjbPM2RZ9hfTNEH6MikldF0HsQvfatvWMR1G2jJTQgPnHMqyhFjIO0VRwMpXhx6TtsyU0KCkLtUYY5DnuRML9tE5dtd3NcpErn1M2jJ/GVqWxYkV+OhcLIecUCYsuxRCAM1G3/cQltD+KMPPOaHsCAVo27ZB0zQvaB+9T2zGxcvCvw3nT84czc+d3B9spTpiz3HEEgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/4.png
// module id = q/uz
// module chunks = 1